import { useState } from "react";
import {
    Box, Button, Container, Divider, FormControl, FormControlLabel, Grid,
    InputLabel, MenuItem, Select, Switch, TextField, Typography, InputAdornment
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MailIcon from '@mui/icons-material/Mail';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import EastIcon from '@mui/icons-material/East';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PlaceIcon from '@mui/icons-material/Place';
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';
import CodeToGenerate from "./CodeToGenerate";
import CheckAttr from "../../utils/CheckAttr";
import { AlertType } from "../../types/AlertType";
import { SnackBarAlert } from "../element/SnackBarAlert";

type PaysType = 'FRANCE' | 'MAROC' | 'TUNISIE' | 'MADAGASCAR' | '';
export interface MainInformation {
    company: number;
    mail: string;
    nom: string;
    prenom: string;
    fonction: string;
    consentement: boolean;
}

export interface AdditionalInformation {
    fixe: string;
    mobile: string;
    adresse: string;
    code_postal: string;
    pays: PaysType;
    active: boolean;
}

const initialMain: MainInformation = {
    company: 1,
    mail: 'mail@outsourcia-group.com',
    nom: 'Nom',
    prenom: 'Prénom',
    fonction: 'Fonction',
    consentement: true
}

const franceAddingInformation: AdditionalInformation = {
    fixe: '+33 1 76 60 21 80',
    mobile: '+33 9 99 99 99 99',
    adresse: '23, rue Lavoisier',
    code_postal: '27 000 Evreux',
    pays: 'FRANCE',
    active: true
}

const marocAddingInformation: AdditionalInformation = {
    fixe: '+212 5 22 95 34 80',
    mobile: '+212 6 99 99 99 99',
    adresse: '217, Boulevard Anfa',
    code_postal: '21000 Casablanca',
    pays: 'MAROC',
    active: true
}

const tunisieAddingInformation: AdditionalInformation = {
    fixe: '+216 36 40 02 00',
    mobile: '+216 9 99 99 99 99',
    adresse: '6 rue des entrepreneurs',
    code_postal: '2035 Charguia II',
    pays: 'TUNISIE',
    active: false
}

const madagascarAddingInformation: AdditionalInformation = {
    fixe: '+261 20 22 572 21',
    mobile: '+261 9 99 99 99 99',
    adresse: 'Enceinte Somalco, ZI Forello - Tanjombato',
    code_postal: 'Antananarivo 102, Madagascar',
    pays: 'MADAGASCAR',
    active: false
}

const Signature = () => {
    const [openSnack, setOpenSnack] = useState<boolean>(false);

    const [alertMessage, setAlerteMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<AlertType>("success");

    const [mainInformation, setMainInformation] = useState<MainInformation>(initialMain);

    const [franceInformation, setFranceInformation] = useState<AdditionalInformation>(franceAddingInformation);
    const [tunisieInformation, setTunisieInformation] = useState<AdditionalInformation>(tunisieAddingInformation);
    const [marocInformation, setMarocInformation] = useState<AdditionalInformation>(marocAddingInformation);
    const [madagascarInformation, setMadagascarInformation] = useState<AdditionalInformation>(madagascarAddingInformation);

    const [additionalInformation, setAdditionalInformation] = useState<AdditionalInformation[]>([franceInformation, marocInformation]);

    const handleChange = (e: any): void => {
        const { name, value } = e.target;

        if (name === 'consentement') {
            setMainInformation({
                ...mainInformation,
                consentement: !mainInformation?.consentement
            });
        } else {
            setMainInformation({
                ...mainInformation,
                [name]: value
            });
        }
    };

    const setAdditionalInformationTab = (data: AdditionalInformation) => {
        let dataToEdit: AdditionalInformation[] = additionalInformation;

        const index = dataToEdit?.findIndex(elem => elem?.pays === data?.pays);

        if (CheckAttr(index)) {
            dataToEdit[index] = data;
        } else {
            dataToEdit?.push(data);
        }

        setAdditionalInformation(dataToEdit);
    };

    const handleChangeFranceInfo = (e: any): void => {
        const { name, value } = e.target;

        if (name === 'active') {
            const val = !franceInformation?.active;
            const data: AdditionalInformation = {
                ...franceAddingInformation,
                active: val
            };

            if (val) {
                let tmpData = additionalInformation;
                tmpData?.push(data);
                setAdditionalInformation(tmpData);
                setFranceInformation(data);
            } else {
                const tmpData = additionalInformation?.filter(elem => elem?.pays !== franceInformation?.pays);

                setAdditionalInformation(tmpData);
                setFranceInformation(data);
            }
        } else {
            const data = {
                ...franceInformation,
                [name]: value
            };

            setFranceInformation(data);
            setAdditionalInformationTab(data);
        }
    };

    const handleChangeMarocInfo = (e: any): void => {
        const { name, value } = e.target;

        if (name === 'active') {
            const val = !marocInformation?.active;

            const data: AdditionalInformation = {
                ...marocAddingInformation,
                active: val
            };

            if (val) {
                let tmpData = additionalInformation;
                tmpData?.push(data);
                setAdditionalInformation(tmpData);
                setMarocInformation(data);
            } else {
                const tmpData = additionalInformation?.filter(elem => elem?.pays !== marocInformation?.pays);

                setAdditionalInformation(tmpData);
                setMarocInformation(data);
            }
        } else {
            const data = {
                ...marocInformation,
                [name]: value
            };

            setMarocInformation(data);
            setAdditionalInformationTab(data);
        }
    };

    const handleChangeTunisieInfo = (e: any): void => {
        const { name, value } = e.target;

        if (name === 'active') {
            const val = !tunisieInformation?.active;

            const data: AdditionalInformation = {
                ...tunisieAddingInformation,
                active: val
            };

            if (val) {
                let tmpData = additionalInformation;
                tmpData?.push(data);
                setAdditionalInformation(tmpData);
                setTunisieInformation(data);
            } else {
                const tmpData = additionalInformation?.filter(elem => elem?.pays !== tunisieInformation?.pays);

                setAdditionalInformation(tmpData);
                setTunisieInformation(data);
            }
        } else {
            const data = {
                ...tunisieInformation,
                [name]: value
            };

            setTunisieInformation(data);
            setAdditionalInformationTab(data);
        }
    };

    const handleChangeMadagascarInfo = (e: any): void => {
        const { name, value } = e.target;

        if (name === 'active') {
            const val = !madagascarInformation?.active;

            const data: AdditionalInformation = {
                ...madagascarAddingInformation,
                pays: 'MADAGASCAR',
                active: val
            };

            if (val) {
                let tmpData = additionalInformation;
                tmpData?.push(data);
                setAdditionalInformation(tmpData);
                setMadagascarInformation(data);
            } else {
                const tmpData = additionalInformation?.filter(elem => elem?.pays !== madagascarInformation?.pays);

                setAdditionalInformation(tmpData);
                setMadagascarInformation(data);
            }
        } else {
            const data = {
                ...madagascarInformation,
                [name]: value
            };

            setMadagascarInformation(data);
            setAdditionalInformationTab(data);
        }
    };

    const handleCopy = () => {
        try {
            const htmlElement = document.getElementById("mySignature")?.innerHTML as any;
            const elem = new Blob([htmlElement], { type: 'text/html' });
            navigator.clipboard.write([new ClipboardItem({ 'text/html': elem })]);

            setAlerteMessage("Copié !");
            setAlertType("success");
            setOpenSnack(true);
        } catch (error) {
            console.log(error);
        }
    };

    const handleCloseAlert = () => {
        setOpenSnack(false);
    };

    const stackAlert: JSX.Element = SnackBarAlert(
        openSnack,
        handleCloseAlert,
        alertType,
        alertMessage
    );

    return (
        <Container maxWidth="xl" sx={{ background: '#fff', my: 4 }}>
            <Grid container spacing={0.5} columns={{ xs: 12, sm: 12, md: 12 }} sx={{ mb: 6 }}>
                <Grid item xs={3.25} sm={3.25} md={3.25} spacing={3}>
                    <FormControl variant="standard" sx={{ minWidth: 120 }} fullWidth>
                        <InputLabel
                            id="demo-simple-select-standard-label"
                            color="warning"
                        >
                            Company
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            name="company"
                            value={mainInformation?.company}
                            onChange={handleChange}
                            label="Company"
                            color="warning"
                            // size="small"
                            sx={{ my: 2 }}
                        >
                            <MenuItem value={1}>OUTSOURCIA</MenuItem>
                            <MenuItem value={2}>STEFI</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        id="standard-basic"
                        label="Adresse mail"
                        variant="standard"
                        fullWidth
                        color="warning"
                        // size="small"
                        sx={{ my: 1 }}
                        name="mail"
                        autoComplete="off"
                        value={mainInformation?.mail}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <MailIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        id="standard-basic"
                        label="Nom"
                        variant="standard"
                        fullWidth
                        color="warning"
                        sx={{ my: 1 }}
                        name="nom"
                        autoComplete="off"
                        value={mainInformation?.nom}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountBoxIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        id="standard-basic"
                        label="Prénom"
                        variant="standard"
                        fullWidth
                        color="warning"
                        // size="small"
                        sx={{ my: 1 }}
                        name="prenom"
                        autoComplete="off"
                        value={mainInformation?.prenom}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountBoxIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        id="standard-basic"
                        label="Fonction"
                        variant="standard"
                        fullWidth
                        color="warning"
                        sx={{ my: 1 }}
                        name="fonction"
                        autoComplete="off"
                        value={mainInformation?.fonction}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountBoxIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <FormControlLabel
                        sx={{ mt: 1, color: '#818181' }}
                        control={<Switch
                            name="consentement"
                            checked={mainInformation?.consentement}
                            onChange={handleChange}
                            color="warning"
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label="Consentement"
                    />

                    <Box display="flex" justifyContent="start" my={4}>
                        <Button
                            variant="contained"
                            color="warning"
                            startIcon={<ContentCopyIcon />}
                            sx={{ textTransform: 'none' }}
                            size="large"
                            onClick={handleCopy}
                        >
                            Copy
                        </Button>
                    </Box>

                    <Typography
                        color="GrayText"
                        variant="subtitle2"
                    >
                        Ajouter une signature a Gmail <EastIcon sx={{ mb: -1 }} />
                    </Typography>
                </Grid>

                <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 2 }} />

                <Grid item xs={4} sm={4} md={4} spacing={1.5}>
                    {/* France */}
                    <Box mt={2} mb={4}>
                        <FormControlLabel
                            sx={{ mt: 1, color: '#818181' }}
                            control={<Switch
                                name="active"
                                checked={franceInformation?.active}
                                onChange={handleChangeFranceInfo}
                                color="warning"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />}
                            label="FRANCE"
                        />
                        <Grid container spacing={3} columns={{ xs: 6, sm: 6, md: 6 }}>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Fixe"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="fixe"
                                    disabled={!franceInformation?.active}
                                    value={franceInformation?.fixe}
                                    onChange={handleChangeFranceInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="Adresse"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="adresse"
                                    disabled={!franceInformation?.active}
                                    value={franceInformation?.adresse}
                                    onChange={handleChangeFranceInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PlaceIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Mobile"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="mobile"
                                    disabled={!franceInformation?.active}
                                    value={franceInformation?.mobile}
                                    onChange={handleChangeFranceInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIphoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="CP"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="code_postal"
                                    disabled={!franceInformation?.active}
                                    value={franceInformation?.code_postal}
                                    onChange={handleChangeFranceInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MarkunreadMailboxIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider />

                    {/* Tunisie */}
                    <Box mt={2}>
                        <FormControlLabel
                            sx={{ mt: 1, color: '#818181' }}
                            control={<Switch
                                name="active"
                                checked={tunisieInformation?.active}
                                onChange={handleChangeTunisieInfo}
                                color="warning"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />}
                            label="TUNISIE"
                        />
                        <Grid container spacing={3} columns={{ xs: 6, sm: 6, md: 6 }}>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Fixe"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="fixe"
                                    value={tunisieInformation?.fixe}
                                    onChange={handleChangeTunisieInfo}
                                    disabled={!tunisieInformation?.active}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="Adresse"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="adresse"
                                    value={tunisieInformation?.adresse}
                                    onChange={handleChangeTunisieInfo}
                                    disabled={!tunisieInformation?.active}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PlaceIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Mobile"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="mobile"
                                    value={tunisieInformation?.mobile}
                                    onChange={handleChangeTunisieInfo}
                                    disabled={!tunisieInformation?.active}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIphoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="CP"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="code_postal"
                                    value={tunisieInformation?.code_postal}
                                    onChange={handleChangeTunisieInfo}
                                    disabled={!tunisieInformation?.active}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MarkunreadMailboxIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 2 }} />

                <Grid item xs={4} sm={4} md={4}>
                    {/* Maroc */}
                    <Box mt={2} mb={4}>
                        <FormControlLabel
                            sx={{ mt: 1, color: '#818181' }}
                            control={<Switch
                                name="active"
                                checked={marocInformation?.active}
                                onChange={handleChangeMarocInfo}
                                color="warning"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />}
                            label="MAROC"
                        />
                        <Grid container spacing={3} columns={{ xs: 6, sm: 6, md: 6 }}>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Fixe"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="fixe"
                                    disabled={!marocInformation?.active}
                                    value={marocInformation?.fixe}
                                    onChange={handleChangeMarocInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="Adresse"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="adresse"
                                    disabled={!marocInformation?.active}
                                    value={marocInformation?.adresse}
                                    onChange={handleChangeMarocInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PlaceIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Mobile"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="mobile"
                                    disabled={!marocInformation?.active}
                                    value={marocInformation?.mobile}
                                    onChange={handleChangeMarocInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIphoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="CP"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="code_postal"
                                    disabled={!marocInformation?.active}
                                    value={marocInformation?.code_postal}
                                    onChange={handleChangeMarocInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MarkunreadMailboxIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider />

                    {/* Madagascar */}
                    <Box mt={2}>
                        <FormControlLabel
                            sx={{ mt: 1, color: '#818181' }}
                            control={<Switch
                                name="active"
                                checked={madagascarInformation?.active}
                                onChange={handleChangeMadagascarInfo}
                                color="warning"
                                inputProps={{ 'aria-label': 'controlled' }}
                            />}
                            label="MADAGASCAR"
                        />
                        <Grid container spacing={3} columns={{ xs: 6, sm: 6, md: 6 }}>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Fixe"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="fixe"
                                    value={madagascarInformation?.fixe}
                                    disabled={!madagascarInformation?.active}
                                    onChange={handleChangeMadagascarInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="Adresse"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="adresse"
                                    value={madagascarInformation?.adresse}
                                    disabled={!madagascarInformation?.active}
                                    onChange={handleChangeMadagascarInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PlaceIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} spacing={3}>
                                <TextField
                                    id="standard-basic"
                                    label="Mobile"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="mobile"
                                    value={madagascarInformation?.mobile}
                                    disabled={!madagascarInformation?.active}
                                    onChange={handleChangeMadagascarInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIphoneIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <TextField
                                    id="standard-basic"
                                    label="CP"
                                    variant="standard"
                                    fullWidth
                                    color="warning"
                                    size="small"
                                    sx={{ my: 1 }}
                                    name="code_postal"
                                    value={madagascarInformation?.code_postal}
                                    disabled={!madagascarInformation?.active}
                                    onChange={handleChangeMadagascarInfo}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MarkunreadMailboxIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>

            <Box display="flex" justifyContent="center">
                <div id="mySignature">
                    <CodeToGenerate
                        mainInformation={mainInformation}
                        additionalInformation={additionalInformation}
                    />
                </div>
            </Box>
            <br></br>

            {/* <OptionalWidthModal
                title="Signature"
                breackPoint="md"
                onClose={handleClose}
                open={openModal}
            >
                <SignatureModal
                    mainInformation={mainInformation}
                    additionalInformation={additionalInformation}
                    onClose={handleClose}
                />
            </OptionalWidthModal> */}

            {stackAlert}
        </Container>
    );
};

export default Signature;